import { render, staticRenderFns } from "./ModalConfirmarBaixarDocumento.vue?vue&type=template&id=c1cbf618&scoped=true"
import script from "./ModalConfirmarBaixarDocumento.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarBaixarDocumento.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmarBaixarDocumento.vue?vue&type=style&index=0&id=c1cbf618&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cbf618",
  null
  
)

export default component.exports